export default __webpack_public_path__ + "static/home-video-c5920c34d2ca903647db03fbd01a6151.mp4";